/**
 * config/index.ts
 * Aggregates and re-exports all configuration.
 * Types are sourced from types/ — only runtime values are exported here.
 */

export { keybinds, devKeybinds } from "./keybinds.settings"
export { fetchConfig } from "./fetch.settings"